<div class="my-3 p-3 bg-dark rounded box-shadow">
  <div  class="border-bottom border-gray pb-2 mb-0">
    <h3>Contact Us</h3>
    <p>
      You may call us at +1 267-234-2397 between the hours of 9:30AM - 4:00PM, Monday - Friday.
      Or email us anytime at: support@stockpilot.app
    </p>
  </div>
</div>
